<template>

  <div
    v-clickoutside.stop="handleCloseCtxMenu"
    :style="contextmenuStyle"
    class="contextmenuClass"
  >
    <div @click="copyComponent">{{$t('lcd.Editor.Copy Component')}}</div>
    <div @click="deleteComponent">{{$t('lcd.Editor.Delete Component')}}</div>
    <div class="divider" />
    <div @click="up">{{$t('lcd.Editor.Up One')}}</div>
    <div @click="down">{{$t('lcd.Editor.Down One')}}</div>
    <div @click="upToTop">{{$t('lcd.Editor.Up To Top')}}</div>
    <div @click="upToBottom">{{$t('lcd.Editor.Down To Bottom')}}</div>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import Clickoutside from "../../../utils/clickoutside.js";
import {
  COMPONENT_AD,
  COMPONENT_VIDEO,
} from "../../../utils/component-attribute";
import { idxOf } from "../../../utils/common";

export default {
  name: "CtxMenu",
  inject: ["getNewComponentId", "checkLimitCnt"],
  directives: {
    Clickoutside,
  },
  computed: {
    ctxMenuVisible: {
      get() {
        return store.state.ctxMenuVisible;
      },
      set(val) {
        store.updateCtxMenuArgs(val);
      },
    },
    // 右键菜单的样式
    contextmenuStyle() {
      return {
        display: store.state.ctxMenuVisible ? "block" : "none",
        // 减一是让菜单弹出来的时候就选第一个菜单项
        left: store.state.ctxMenuLeft - 1 + "px",
        top: store.state.ctxMenuTop - 1 + "px",
      };
    },
    isGroupMenu() {
      return store.state.multipleComponentList.length;
    },
  },
  methods: {
    // 如果在右键菜单显示的时候。点击外部。隐藏自己
    handleCloseCtxMenu(e) {
      console.log(store.state.ctxMenuVisible)
      if (store.state.ctxMenuVisible) {
        store.updateCtxMenuArgs(false);
      }
    },
    // 复制组件
    copyComponent() {
      // 最多有一个视频、一个音乐
      if (
        store.state.activeComponent.type === COMPONENT_AD ||
        store.state.activeComponent.type === COMPONENT_VIDEO
      ) {
        const result = this.checkLimitCnt();
        if (store.state.activeComponent.type === COMPONENT_VIDEO) {
          if (result.videoCount !== 0) {
            this.$message.warning("最多支持一个视频组件");
            // 关闭右键菜单
            store.updateCtxMenuArgs(false);
            return;
          }
        }
        if (store.state.activeComponent.type === COMPONENT_AD) {
          if (result.adCount !== 0) {
            this.$message.warning("最多支持一个视频组件");
            // 关闭右键菜单
            store.updateCtxMenuArgs(false);
            return;
          }
        }
      }

      // 复制之前的配置
      const newComponentConf = JSON.parse(
        JSON.stringify(store.state.activeComponent)
      );
      // 重新生成id
      newComponentConf.componentId = this.getNewComponentId();

      store.addComponent(newComponentConf);
      store.updateCtxMenuArgs(false);
    },
    // 删除组件
    deleteComponent() {
      const obj = {
        component: store.state.activeComponent,
        index: idxOf(
          store.state.currentPageComponentList,
          store.state.activeComponent,
          "componentId"
        ),
      };
      console.log("obj  ", obj);
      this.$emit("delete-component", obj);
      store.updateCtxMenuArgs(false);

      // // 找到节目在列表中的位置
      // const idx = this.programData.pages[this.currentPageIndex].componentList.indexOf(store.state.activeComponent)
      // // 生成节目的拷贝
      // const newProgramData = JSON.parse(JSON.stringify(this.programData))
      // // 把节目从拷贝中移除
      // newProgramData.pages[this.currentPageIndex].componentList.splice(idx, 1)
      // // 拷贝替换原节目
      // this.$emit('update:programData', newProgramData)
      // // 关闭右键菜单
      // this.ctxMenuVisible = false
    },
    up() {
      // 找出当前组件上边的所有组件
      const aboveComponentList = [];
      for (let i = 0; i < store.state.currentPageComponentList.length; i++) {
        if (
          store.state.currentPageComponentList[i].zIndex >
          store.state.activeComponent.zIndex
        ) {
          aboveComponentList.push(store.state.currentPageComponentList[i]);
        }
      }
      if (aboveComponentList.length) {
        aboveComponentList.sort((a, b) => {
          return a.zIndex - b.zIndex;
        });
        // 找到组件上边的那个组件
        const idx = idxOf(
          store.state.currentPageComponentList,
          aboveComponentList[0],
          "componentId"
        );
        const tmpZIndex = store.state.activeComponent.zIndex;
        store.state.activeComponent.zIndex =
          store.state.currentPageComponentList[idx].zIndex;
        store.state.currentPageComponentList[idx].zIndex = tmpZIndex;
      } else {
        this.$message({
          message: "已经移到顶层了",
          type: "info",
          showClose: true,
        });
      }
      store.updateCtxMenuArgs(false);
    },
    down() {
      // 找出当前组件下边的所有组件
      const downComponentList = [];
      for (let i = 0; i < store.state.currentPageComponentList.length; i++) {
        if (
          store.state.currentPageComponentList[i].zIndex <
          store.state.activeComponent.zIndex
        ) {
          downComponentList.push(store.state.currentPageComponentList[i]);
        }
      }
      if (downComponentList.length) {
        downComponentList.sort((a, b) => {
          return b.zIndex - a.zIndex;
        });
        // 找到组件下边的那个组件
        const idx = idxOf(
          store.state.currentPageComponentList,
          downComponentList[0],
          "componentId"
        );
        const tmpZIndex = store.state.activeComponent.zIndex;
        store.state.activeComponent.zIndex =
          store.state.currentPageComponentList[idx].zIndex;
        store.state.currentPageComponentList[idx].zIndex = tmpZIndex;
      } else {
        this.$message({
          message: "已经移到底层了",
          type: "info",
          showClose: true,
        });
      }
      store.updateCtxMenuArgs(false);
    },
    upToTop() {
      // 找到最上边的组件
      let topComponent = store.state.activeComponent;
      // 找出当前组件上边的所有组件
      const aboveComponentList = [];
      for (let i = 0; i < store.state.currentPageComponentList.length; i++) {
        if (
          store.state.currentPageComponentList[i].zIndex >
          store.state.activeComponent.zIndex
        ) {
          if (
            store.state.currentPageComponentList[i].zIndex > topComponent.zIndex
          ) {
            topComponent = store.state.currentPageComponentList[i];
          }
          aboveComponentList.push(store.state.currentPageComponentList[i]);
        }
      }
      if (topComponent === store.state.activeComponent) {
        this.$message({
          message: "已经移到顶层了",
          type: "info",
          showClose: true,
        });
      } else {
        store.state.activeComponent.zIndex = topComponent.zIndex;
        for (let i = 0; i < aboveComponentList.length; i++) {
          aboveComponentList[i].zIndex -= 1;
        }
      }
      store.updateCtxMenuArgs(false);
    },
    upToBottom() {
      // 找到最下边的组件
      let bottomComponent = store.state.activeComponent;
      // 找出当前组件下边的所有组件
      const bottomComponentList = [];
      for (let i = 0; i < store.state.currentPageComponentList.length; i++) {
        if (
          store.state.currentPageComponentList[i].zIndex <
          store.state.activeComponent.zIndex
        ) {
          if (
            store.state.currentPageComponentList[i].zIndex <
            bottomComponent.zIndex
          ) {
            bottomComponent = store.state.currentPageComponentList[i];
          }
          bottomComponentList.push(store.state.currentPageComponentList[i]);
        }
      }
      if (bottomComponent === store.state.activeComponent) {
        this.$message({
          message: "已经移到底层了",
          type: "info",
          showClose: true,
        });
      } else {
        store.state.activeComponent.zIndex = bottomComponent.zIndex;
        for (let i = 0; i < bottomComponentList.length; i++) {
          bottomComponentList[i].zIndex += 1;
        }
      }
      store.updateCtxMenuArgs(false);
    },
    componentGroup() {
      this.$confirm("此操作将重新将选中组件分组, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        store.groupMultipleComponent();
        this.$message({
          type: "success",
          message: "分组成功!",
        });
      });
      store.updateCtxMenuArgs(false);
    },
  },
};
</script>

<style lang="scss" scoped>
// 右键菜单
.contextmenuClass {
  border-radius: 4px;
  position: absolute;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  z-index: 11;
  > div {
    cursor: pointer;
    padding: 4px 8px;
    user-select: none;
    &:not(.divider):hover {
      background: #f66;
      color:#fff;
    }
    &:first-of-type {
      border-radius: 4px 4px 0 0;
    }
    &:last-of-type {
      border-radius: 0 0 4px 4px;
    }
    &.divider {
      height: 1px;
      margin: 4px 4px;
      padding: 0;
      background-color: #aaa;
    }
  }
}
</style>
